<template>
 <label :for="inputId" class="form-label"
          >{{ labelText }}
        </label>
        <slot name="subLabel"></slot>
        <div class="d-flex align-items-center flex-column flex-sm-row " style="gap: 5px;">
          <textarea class="form-control" :id="inputId" v-model="inputField" :required="required" maxlength="1000"></textarea>
          <slot name="nextTextarea"></slot>
        </div>
        <span> {{ intl[$store.state.lang]["remaining-characters"]}}{{ 1000 - this.inputField.length }} {{ intl[$store.state.lang]["characters"] }}  </span>
     
</template>

<script>
import intl from "./intl/intl";


export default {
  name: "textArea",
  components: {
   
   
  },

  props: {
      
      inputId: {
        type: String,
        default: null
      },
      
      labelKey: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },

      defaultValue: {
        type: String,
        default: ''
      }
     
        
  },
  mounted() {
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
      inputField: this.defaultValue
    };
  },
  methods: {
     requiredInputIsOk(){
       if(this.required && this.inputField === ""){
         return false
       }
       return true
     }
  },
 watch: {
    inputField(newValue, oldValue) {
      // Emit dell'evento 'value-changed' con il nuovo valore
      this.$emit('textArea-changed', newValue);
    }
  },
  computed: {
        labelText: function () {
      if(this.required){
        return this.intl[this.$store.state.lang][this.labelKey] + '*:'
      }else{
        return this.intl[this.$store.state.lang][this.labelKey] + ':'
      }
       
    },
    },
  
};
</script>
